// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3J08n","large":"styles_large__3vvAD"};